import { shallowRef } from "vue";

import { projects as projectsApi } from "~/api";
import { fetch } from "~/utils/api";

/**
 * Composable for project toggle action.
 *
 * @param {object} options
 * @param {Function} options.onToggle - called with (projectId, enabled) after successful toggle
 * @returns {{
 *   actionAlert: import('vue').ShallowRef<object|null>,
 *   handleToggle: Function
 * }}
 */
export function useProjectActions({ onToggle }) {
  const actionAlert = shallowRef(null);

  async function handleToggle(project, enabled) {
    actionAlert.value = null;
    await fetch({
      alert: actionAlert,
      apiMethod: projectsApi.toggle,
      onSuccess(data) {
        onToggle(project.id, enabled);
        actionAlert.value = data;
      },
      requestArgs: { data: { enabled }, params: { id: project.id } }
    });
  }

  return { actionAlert, handleToggle };
}
